
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/bestseller/[categoryName]",
      function () {
        return require("private-next-pages/home/bestseller/[categoryName].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/bestseller/[categoryName]"])
      });
    }
  